<div class="woms">

    <div class="woms-column">
        <nav class="sidenav">
            <div class="sidenav-items">
                <div *ngIf="isBpsAdmin" class="utilityFilter">
                    <select name="utility-select" (change)="selectUtilityChild($event)" class="form-select">
                        <option value="" [selected]="selectedUtilityId==0" [disabled]="true" value=0>All</option>
                        <option *ngFor="let u of utilityList" value={{u.key}}>
                        {{u.value}}
                        </option>
                    </select>
                </div>
                <a class="nav-item item-active" (click)="switchMenuItem(WorkOrderMenuItem.Maintenance)"
                    *ngIf="permissionsService.isWorkOrderMaintenanceAllowed">
                    <span>{{ "COMMON.MAINTENANCE" | translate }} </span>
                </a>
            </div>
        </nav>
    </div>
    <div class="selected-wom">
        <ng-container [ngSwitch]="workOrderSelected">
            <app-maintenance-list *ngSwitchCase="WorkOrderMenuItem.Maintenance" ></app-maintenance-list>
        </ng-container>
    </div>
</div>